module.exports = __webpack_public_path__ + "res/22-img_card_bg.90686e4d68bfad72cb56a8e9474ab91b.png";